import {RouteObject} from 'react-router-dom';

import ReferentialLayout from '@modules/referential/layout/ReferentialLayout';
import DatatableStoreProvider from '@common/stores/DatatableStoreProvider';

const piuRoutes: RouteObject[] = [
  {
    path: 'referentials',
    element: <ReferentialLayout />,
    children: [
      {
        index: true,
        async lazy() {
          const {default: ReferentialDashboard} = await import('@modules/referential/pages/ReferentialDashboard');

          return {
            element: (
              <DatatableStoreProvider>
                <ReferentialDashboard />
              </DatatableStoreProvider>
            )
          };
        }
      }
    ]
  }
];

export default piuRoutes;
